import '@ll-platform/frontend/config/setupSentry';
import '@ll-platform/frontend/config/setupLoadErrorHandler';
import '@ll-platform/frontend/config/setupYup';
import '@ll-platform/frontend/config/setupDayjs';
import '@ll-platform/frontend/main.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './container/App';

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
